import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-privacy',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './privacy.html',
    styles: [`
    .legal-container {
      max-width: 800px;
      margin: 0 auto;
      padding: 2rem 1.5rem 4rem;
    }
    h1 { margin-bottom: 2rem; }
    h2 { margin-top: 2rem; margin-bottom: 1rem; font-size: 1.25rem; }
    p { margin-bottom: 1rem; color: var(--text-secondary); }
    ul { margin-bottom: 1rem; padding-left: 1.5rem; color: var(--text-secondary); }
    li { margin-bottom: 0.5rem; }
    .last-updated { font-size: 0.85rem; color: var(--text-secondary); margin-bottom: 2rem; font-style: italic; }
  `]
})
export class PrivacyComponent { }
